interface ApiEnv {
  VITE_API_URL?: string;
}

/** Resolve the backend base URL. Empty (the default) means same-origin — the
 *  SPA is served by the API service itself. `VITE_API_URL` overrides it only
 *  when the SPA is hosted on a different origin. Trailing slash stripped so
 *  callers can append `/api/...` uniformly. */
export const resolveApiBase = (env: ApiEnv): string => (env.VITE_API_URL ?? '').replace(/\/$/, '');

export const API_BASE = resolveApiBase(import.meta.env as unknown as ApiEnv);

/** Base URL for WebSocket connections (trip sync). When `apiBase` is an absolute
 *  http(s) URL, swap the scheme to ws(s). When it's empty — the same-origin
 *  unified deploy — derive `ws(s)://host` from the page location, since the
 *  `WebSocket` constructor rejects a relative URL. */
export const resolveWsBase = (
  apiBase: string,
  location: { protocol: string; host: string },
): string => {
  if (apiBase) return apiBase.replace(/^http/, 'ws');
  const scheme = location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${scheme}//${location.host}`;
};

export const WS_BASE = resolveWsBase(
  API_BASE,
  typeof window !== 'undefined' ? window.location : { protocol: 'http:', host: 'localhost' },
);
